import { Permissions } from '../client_auth/permissions'

manageDomains.$inject = ['graph', 'domains', '$uibModal', 'auth']

export default function manageDomains(graph, domainService, $modal, auth) {
  return {
    restrict: 'EA',
    scope: {},
    link: function(scope, elm, attrs) {
      auth.hasUserOpsPermission().then(hasPermission => {
        scope.hasUserOpsPermission = hasPermission;
      });

      if (domainService.UI.domains.length === 0) {
        domainService.refreshDomains()
      }

      scope.ui = domainService.UI

      // create domain modal
      scope.onDomainCreated = function(domain) {
        // reload list of schools
        domainService.refreshDomains()
      }
      scope.createDomainModal = function() {
        var modalInstance = $modal.open({
          scope: scope,
          controller: [
            '$uibModalInstance',
            function($modalInstance) {
              this.close = function() {
                $modalInstance.dismiss()
              }
              this.onDomainCreated = function(domain) {
                $modalInstance.close(domain)
              }
              this.domainNames = domainService.UI.domainNames
            }
          ],
          controllerAs: 'modalCtrl',
          template:
            '' +
            '<div class="modal-body">' +
            '<a class="close" ng-click="modalCtrl.close()">&times;</a>' +
            '<div create-domain-entity on-domain-created="modalCtrl.onDomainCreated(domain)" domain-names="modalCtrl.domainNames"></div>' +
            '</div>'
        })
        modalInstance.result.then(scope.onDomainCreated)
      }

      scope.reload = function() {
        domainService.refreshDomains()
      }
    },
    template:
      '<p class="pull-right"><button class="btn btn-primary" ng-click="createDomainModal()" ng-if="hasUserOpsPermission">Create domain</button> <button class="btn btn-default" ng-click="reload()">Reload domains</button></p>' +
      '<div domain-list="ui.domains" last-updated="ui.lastFetched" loading="ui.loading"></div>'
  }
}
